import { ModuleFE_EHRInstanceKBVersion } from './ModuleFE_EHRInstanceKBVersion.js';
export const ModulePackFE_EHRInstanceKBVersionDB = [ModuleFE_EHRInstanceKBVersion];
//# sourceMappingURL=module-pack.js.map